import { reactive } from 'vue';

import {
	DEFAULT_BAND_ID,
	DEFAULT_HOURS_PER_TICKET,
	DEFAULT_SHARE,
	getBandById,
} from './calculations.js';

const defaultBand = getBandById(DEFAULT_BAND_ID);

const store = reactive({
	band: defaultBand.id,
	volume: defaultBand.avg,
	hours: DEFAULT_HOURS_PER_TICKET,
	share: DEFAULT_SHARE,

	/**
	 * Switch the selected team size band and reset monthly ticket volume to the
	 * typical volume for that band.
	 *
	 * @param {string} bandId - Identifier of the selected team size band.
	 */
	setBand(bandId) {
		const band = getBandById(bandId);
		this.band = band.id;
		this.volume = band.avg;
	},
});

export default store;
